import { BlocState } from 'src/app/shared/bloc/base-bloc';

export abstract class ConfirmationState extends BlocState {}

export class ConfirmationReadyState<T> extends BlocState {
  constructor(public data: T) {
    super();
  }
}
